export default __webpack_public_path__ + "static/media/phonogram.de212fd6.jpg";